import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import { useYouScreen } from "../YouScreenContext";
import PersonalInfo from "../sections/PersonalInfo";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "PersonalInfoDetail">;

export default function PersonalInfoDetailScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { personalMedical } = useYouScreen();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.personal_info")}
      onBack={handleBack}
    >
      <PersonalInfo data={personalMedical} onClose={handleBack} />
    </YouDetailScreenLayout>
  );
}
